import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class PostalAddress
*  Собственный адрес склада. Обязателен на входе API; в базе допускает<br>`null`, потому что миграция не может выдумать адрес складам,<br>у которых не было привязки к справочнику СДЭК.<br>
*/
export class PostalAddress extends ActiveModel {

/**
  * countryCode
  * Код страны ISO alpha-2.
  */
  @ActiveField()
  countryCode?: string


/**
  * postalCode
  * Почтовый индекс.
  */
  @ActiveField()
  postalCode?: null | string


/**
  * city
  * Населённый пункт.
  */
  @ActiveField('')
  city: string = ''


/**
  * line
  * Улица, дом, помещение — одной строкой.
  */
  @ActiveField('')
  line: string = ''


  /**
  * latitude
  * Широта, если известна.  */
  @ActiveField()
  latitude?: null | number


  /**
  * longitude
  * Долгота, если известна.  */
  @ActiveField()
  longitude?: null | number
}
